import {
  ChangeDetectionStrategy,
  Component,
  ViewEncapsulation,
  input,
} from '@angular/core';

import { ReportFmtPipe, ReportTPipe } from '../report-i18n.pipe';
import { ReportView } from '../report.model';

/**
 * Bloc de clôture du rapport : la recommandation pédagogique.
 *
 * **Volontairement stable d'un thème à l'autre.** C'est le bloc de marque qui
 * ferme le document : `--primary` inverse sa clarté entre les deux thèmes, ce
 * qui ferait passer ce pavé de blanc-sur-bleu à marine-sur-bleu-vif. La
 * feuille de styles y fixe donc des couleurs en dur — ce n'est pas un oubli de
 * jetons, ne pas le « corriger ».
 *
 * Pas d'apparition au défilement non plus : il ferme la page, et l'atteindre
 * suffit à l'avoir lu.
 */
@Component({
  selector: 's2e-report-footer',
  standalone: true,
  encapsulation: ViewEncapsulation.None,
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [ReportFmtPipe, ReportTPipe],
  templateUrl: './report-footer.section.html',
  host: { '[style.display]': "'contents'" },
})
export class ReportFooterSection {
  readonly view = input.required<ReportView>();
}
